var map = {
	"./LOGO.svg": "0f6e",
	"./Path.svg": "c013",
	"./arrow.svg": "21e2",
	"./arrow_down.svg": "4b1a",
	"./bell.svg": "3d56",
	"./builder.svg": "dfd6",
	"./checked-green.svg": "e5a2",
	"./closeIcon.svg": "df2e",
	"./coins/arrow.svg": "dd66",
	"./coins/coin24gold.svg": "eeb6",
	"./coins/copper.svg": "f4a1",
	"./coins/euro.svg": "ac61",
	"./coins/gas.svg": "cab3",
	"./coins/gold18.svg": "ab8d",
	"./coins/gold21.svg": "f018",
	"./coins/oil.svg": "f26a",
	"./coins/ok.svg": "07b1",
	"./coins/platinum.svg": "28dc",
	"./coins/silver.svg": "6837",
	"./coins/smallCoins/arrow-down.svg": "99de9",
	"./coins/smallCoins/arrow-up.svg": "d594",
	"./coins/smallCoins/combinethreecoins.svg": "f93b",
	"./coins/smallCoins/gas.svg": "1f69",
	"./coins/smallCoins/gold18.svg": "1daf",
	"./coins/smallCoins/oil.svg": "baa3",
	"./coins/smallCoins/platinum.svg": "71e4",
	"./coins/smallCoins/silver.svg": "deee",
	"./coins/usd.svg": "f208",
	"./cover.svg": "ac5f",
	"./history.svg": "14e1",
	"./list.svg": "99ad",
	"./loss.svg": "88e4",
	"./plus.svg": "eb38",
	"./profit.svg": "265a",
	"./search.svg": "d103",
	"./user-default.svg": "e570",
	"./verified.svg": "256c",
	"./wallet.svg": "4f4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";